import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { MenuMaster } from 'models/role';
import { ResponseError } from 'models/common/respone.model';

export function useEditMasterMenu(
    options?: UseMutationOptions<
        ResponseError,
        AxiosError<ResponseError>,
        MenuMaster
    >
) {
    return useMutation({
        mutationFn: request => {
            const accessToken = localStorage.getItem('WF_APPLICATION');
            return axios.put('/v1/configuration/workflow/menu', request, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
        },
        ...options
    });
}
